import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { ConstantsService } from 'app/services/constants-service';
import { Observable } from 'rxjs/Observable';

import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { EntityIdDetails, EntityType } from 'app/shared/models/entity-id-details.model';
import { EntitySurveysService } from 'app/entities/surveys/entity-surveys.service';
import { SurveyInstance } from 'app/entities/surveys/survey-instance.model';
import { MessageService } from 'app/services/messages.service';
import { GenericSearchDetails } from 'app/shared/models/generic-search-details.model';
import { SurveyQuestionType } from 'app/shared/models/survey/survey-question-type.enum';
import { TransactionProfileDescService } from 'app/entities/transaction-profile/transactionprofiledesc/transaction-profile-desc.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { SurveyResponse } from 'app/entities/surveys/save-response.model';

@Component({
  selector: 'survey-details',
  templateUrl: './survey-details.component.html',
})
export class SurveyDetailsComponent implements OnChanges {
  @Input() surveyDetails: SurveyInstance;
  @Input() entityId: number;
  @Input() isSurveyTab = false;
  surveyResponses = new Array<SurveyResponse>();
  questionTypes: ApplicationValue[];
  selectedEntity: GenericSearchDetails;
  searchURI = ConstantsService.ADD_RELATION_SEARCH;
  questionType = SurveyQuestionType;
  surveyPlaceholder = MessageService.HEADER_SEARCH_PLACEHOLDER;
  entityName = new Array<String>();

  isLoading = false;
  constructor(private entitySurveysService: EntitySurveysService,
    private warmUpService: WarmUpService,
    private formBuilder: FormBuilder,
    private snackBarService: SnackBarService,
    private transactionProfileDescService: TransactionProfileDescService) { }

  // TODO(jagpreet.singh): Temporarily handling this as surveyDetails are undefined when ngOnInit is called.
  ngOnChanges() {
    if (!this.questionTypes) {
      const setQuestionTypes = (values) => {
        this.questionTypes = values;
      };
      this.warmUpService.getApplicationValueList(ApplicationTypeConstants.SURVEY_QUESTION_TYPE, setQuestionTypes);
    }
    if (this.surveyDetails && this.surveyDetails.questions.length !== this.surveyResponses.length) {
      this.surveyDetails.questions.forEach(element => {
        this.loadSurveyResponse(element);
      });
    }
  }

  loadSurveyResponse(element) {
    const surveyResponse = new SurveyResponse();
    surveyResponse.questionId = element.id;
    this.populateSurveyResponses(surveyResponse, element);
    this.surveyResponses.push(surveyResponse);
  }

  resetSurvey(element) {
    this.surveyResponses.forEach(surveyResponse => {
      this.populateSurveyResponses(surveyResponse, element);
    });
  }

  populateSurveyResponses(surveyResponse, element) {
    if (this.isMultipleChoiceQuestionType(element.type)) {
      surveyResponse.optionId = element.optionAnswer;
      this.entityName.push('');
    } else if (this.isParagraphTextQuestionType(element.type)) {
      surveyResponse.responseText = element.openAnswer;
      this.entityName.push('');
    } else if (this.isEntityLookUpQuestionType(element.type)) {
      if (element.responsePerson) {
        surveyResponse.personId = element.responsePerson.id;
        this.entityName.push(element.responsePerson.callingName);
      } else if (element.responseOrganisation) {
        surveyResponse.organisationId = element.responseOrganisation.id;
        this.entityName.push(element.responseOrganisation.name);
      } else {
        this.entityName.push('');
      }
    }
  }

  onEntitySelection(searchDetails: GenericSearchDetails, index) {
    if (searchDetails.entityType === 'Person') {
      this.surveyResponses[index].personId = searchDetails.id;
    } else {
      this.surveyResponses[index].organisationId = searchDetails.id;
    }
    this.entityName[index] = searchDetails.clientName;
  }

  updateQuestionTypes(response: ApplicationValue[]) {
    this.questionTypes = response;
  }

  onSubmit(): void {
    this.isLoading = true;
    this.entitySurveysService.saveSurveyResponses(this.surveyResponses).subscribe(
      response => {
        if (response.flagResult && !this.isSurveyTab) {
          this.reloadSurveyDetails();
        }
        this.callSnackBarService(response);
        this.isLoading = false;
      },
      err => {
        this.callSnackBarService(err);
      }
    );
  }

  callSnackBarService(response: any) {
    this.snackBarService.showStatus(response,
      MessageService.SAVE_SURVEY_RESPONSE_SUCCESS,
      MessageService.SAVE_SURVEY_RESPONSE_FAILURE);
  }

  getQuestionType(id: number) {
    if (this.questionTypes) {
      return this.questionTypes.find(question => question.id === id).name;
    }
  }

  isMultipleChoiceQuestionType(typeId) {
    return this.getQuestionType(typeId) === SurveyQuestionType.MULTIPLE_CHOICE.toString();
  }

  isEntityLookUpQuestionType(typeId) {
    return this.getQuestionType(typeId) === SurveyQuestionType.ENTITY_LOOKUP.toString();
  }

  isParagraphTextQuestionType(typeId) {
    return this.getQuestionType(typeId) === SurveyQuestionType.PARAGRAPH_TEXT.toString();
  }

  onCancel() {
    this.surveyDetails.questions.forEach(element => {
      this.resetSurvey(element);
    });
  }

  reloadSurveyDetails() {
    this.transactionProfileDescService.getTransactionProfileDesc(this.entityId)
      .subscribe(response => {
        this.surveyDetails = response;
      });
  }

  onChange(event, index) {
    if (!event) {
      const questionId = this.surveyResponses[index].questionId;
      this.surveyResponses[index] = new SurveyResponse();
      this.surveyResponses[index].questionId = questionId;
    }
  }

  isSurveyResponseValid(): boolean {
    const invalidSurveyResponses = this.surveyResponses
      .filter(response => {
        return this.surveyDetails.questions.find(question => question.id === response.questionId && question.required);
      }).find(response => !(response.organisationId || response.personId || response.responseText || response.optionId));
    return invalidSurveyResponses != null;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/surveys/surveyDetails/survey-details.component.ts